import {
  SizableText,
  SizableTextProps,
  SmartLink,
  XStack,
  XStackProps,
  YStack,
  YStackProps,
} from '@my/ui'
import millify from 'millify'
import { Image } from 'app/types'
import { GroupAvatar } from '../../components'

export interface GroupCardInfoProps {
  name: string
  href: string
  visibility?: string
  totalMembers: number
  profileImage?: Image
  infoWrapperProps?: YStackProps
  titleProps?: SizableTextProps
  shareable?: boolean
}

export const GroupCardInfo = ({
  name,
  href,
  visibility,
  totalMembers,
  profileImage,
  infoWrapperProps,
  titleProps,
  ...props
}: GroupCardInfoProps & XStackProps) => {
  return (
    <SmartLink
      Component={XStack}
      href={href}
      ai="flex-start"
      gap="$3.5"
      hoverStyle={{
        opacity: 0.8,
      }}
      focusStyle={{
        opacity: 0.7,
      }}
      pressStyle={{
        opacity: 0.75,
      }}
      {...props}
    >
      <YStack ai="center" jc="center" overflow="hidden" aspectRatio={1}>
        <GroupAvatar
          width={42}
          height={42}
          src={profileImage?.url}
          alt={profileImage?.alt || name}
          rounded={false}
          $gtSm={{
            w: 64,
            h: 64,
          }}
          $gtMd={{
            w: 92,
            h: 92,
          }}
        />
      </YStack>
      <YStack flex={1} ai="flex-start" gap="$2">
        <SizableText numberOfLines={3} lineHeight="$4" size="$5" fow="600" {...titleProps}>
          {name}
        </SizableText>
      </YStack>
    </SmartLink>
  )
}
